export default class LoadGoogleAPI {

  /**
   * Creates an instance of LoadGoogleAPI.
   * @param {Object} An object of param settings.
   *
   * @memberOf LoadGoogleAPI
   */
  constructor(options) {
    this._callbackName = '__googleApiOnLoadCallback';
    this._clientURL = `https://apis.google.com/js/api.js?onload=${this._callbackName}`;
    this._apiKey = options.apiKey;
    this._clientId = options.clientId;
    this._discoveryDocs = options.discoveryDocs;
    this._scope = options.scope.join(' ');
    this.name = 'load-google-api';
    this.script = null;

    if (window.localStorage != null) {
      let storagePrefix = "google_calendar_";
      this.readStorage = function(key) {
        return window.localStorage[storagePrefix + key];
      };
      this.writeStorage = function(key, value) {
        if (value === null) {
          return delete window.localStorage[storagePrefix + key];
        } else {
          return (window.localStorage[storagePrefix + key] = value);
        }
      };
    } else {
      this.readStorage  = function() {};
      this.writeStorage = function() {};
    }
  }

  /**
   * Injects the Google API Client script into the browser and
   * attaches a handler.
   * @returns {Promise} Returns a promise after injection.
   *
   * @memberOf LoadGoogleAPI
   */
  loadGoogleAPI() {
    return new Promise((resolve, reject) => {
      const clientScriptElement = document.createElement('script');

      clientScriptElement.src = this._clientURL;

      window[this._callbackName] = () => {
        console.log("loadGoogleAPI: calling init");
        this.init(resolve, reject);
      }

      this.script = document.body.appendChild(clientScriptElement);
    });
  }

  /**
   * After the google api client library is loaded in the browser,
   * this function performs initialization of the client using the
   * credentials from auth file.
   * @returns {Promise} Returns a promise after successful login.
   *
   * @memberOf LoadGoogleAPI
   */
  init(resolve, reject) {

    let loadGapiClient = new Promise((resolve, reject) => {

      console.log("LoadGoogleAPI: loading client:auth2");
      window.gapi.load('client:auth2', () => {

        console.log("LoadGoogleAPI: loading client.init");
        window.gapi.client.init({
          apiKey: this._apiKey,
          client_id: this._clientId,
          discoveryDocs: this._discoveryDocs,
          scope: this._scope
        }).then(() => {
          resolve()
        }).catch(reject);

      });
    });

    Promise.all([loadGapiClient]).then(resolve).catch(reject)
  }

  /**
   *
   *
   */
  unload() {
    console.log("LoadGoogleAPI: unload");
    this.script.remove();
    // TODO: delete gapi
  }
}
